var React = require('react');

function Bubble (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Interdictor"),React.createElement("circle",{"className":"cls-1","cx":"64","cy":"64","r":"47.7","key":2})]);
}

Bubble.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Bubble;

Bubble.default = Bubble;
